import { FC, SVGProps } from 'react';

export const HostUsersIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none" {...props}>
		<path
			d="M17.044 15.3695C17.044 14.0062 15.737 12.8472 13.9136 12.4167M12.3483 15.3695C12.3483 13.6399 10.2462 12.2391 7.65268 12.2391C5.05912 12.2391 2.95703 13.6399 2.95703 15.3695M12.3483 9.89124C13.1786 9.89124 13.9748 9.56143 14.5619 8.97436C15.149 8.38729 15.4788 7.59105 15.4788 6.76081C15.4788 5.93056 15.149 5.13432 14.5619 4.54725C13.9748 3.96018 13.1786 3.63037 12.3483 3.63037M7.65268 9.89124C6.82244 9.89124 6.0262 9.56143 5.43913 8.97436C4.85206 8.38729 4.52225 7.59105 4.52225 6.76081C4.52225 5.93056 4.85206 5.13432 5.43913 4.54725C6.0262 3.96018 6.82244 3.63037 7.65268 3.63037C8.48293 3.63037 9.27917 3.96018 9.86624 4.54725C10.4533 5.13432 10.7831 5.93056 10.7831 6.76081C10.7831 7.59105 10.4533 8.38729 9.86624 8.97436C9.27917 9.56143 8.48293 9.89124 7.65268 9.89124Z"
			stroke="currentColor"
			strokeWidth="1.56522"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
